import { useMemo } from 'react';
import { useUpdateSolutionViewerDatacenterAccessMutation } from '../api';
/**
 * Hook to update a user's solution viewer datacenter access.
 *
 * @returns a mutation function to update solution viewer datacenter access.
 */
export const useUpdateSolutionViewerDatacenterAccess = () => {
    const [updateSolutionViewerDatacenterAccess, { isLoading, isError, error }] = useUpdateSolutionViewerDatacenterAccessMutation();
    return useMemo(() => ({
        updateSolutionViewerDatacenterAccess,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, updateSolutionViewerDatacenterAccess]);
};
